export function markupContentTextMessage() {
  return ` 
    <div class="my-library-content-wrap">
  <p class="my-library-text-message">
    <span>OOPS...</span>
    <span>We are very sorry!</span>
    <span>You don’t have any movies at your library.</span>
  </p>
  <a class="button-accent" href="./catalog.html">Search movie</a>
</div>
    `;
}
